import React from 'react';
import { FaChartLine, FaCrown, FaLink, FaRegClock, FaTrash } from 'react-icons/fa';
import GiftSetService from '../../services/GiftSetService';
import { formatDateTime } from './giftSetUiUtils';

const GiftSetDeviceCard = ({
  member,
  onRemove,
  theme,
  variant = 'member',
}) => {
  const isOwner = variant === 'owner';
  const scanCount = Number(member.scanCount || 0);
  const title = member.nickname || (isOwner ? 'Owner NFC' : 'NFC Member');
  const statusLabel = isOwner ? 'Master device' : 'Member entry';

  return (
    <div
      className="relative overflow-hidden rounded-[1.15rem] border p-4"
      style={{ borderColor: isOwner ? theme.accent : theme.cardBorder, backgroundColor: theme.cardBg }}
    >
      {isOwner && (
        <div className="absolute right-3 top-3 h-16 w-16 rounded-full opacity-20 blur-xl" style={{ backgroundColor: theme.accentSoft }} />
      )}

      <div className="relative flex items-start justify-between gap-3">
        <div className="flex min-w-0 flex-1 items-start gap-3">
          <div
            className="flex h-10 w-10 shrink-0 items-center justify-center rounded-[0.95rem]"
            style={{ backgroundColor: isOwner ? theme.accent : theme.accentSoft, color: isOwner ? '#fff' : theme.accent }}
          >
            {isOwner ? <FaCrown /> : <FaLink />}
          </div>

          <div className="min-w-0 flex-1">
            <div className="flex flex-wrap items-center gap-2">
              <p className="truncate text-sm font-black" style={{ color: theme.text }}>
                {title}
              </p>
              <span
                className="rounded-full px-2 py-1 text-[8px] font-black uppercase tracking-widest"
                style={{ backgroundColor: theme.accentSoft, color: theme.accent }}
              >
                {isOwner ? 'Owner' : 'Linked'}
              </span>
            </div>

            <p className="mt-1 text-[10px] font-bold opacity-50">
              {GiftSetService.formatShortUuid(member.uuid)}
            </p>

            <div className="mt-3 grid grid-cols-2 gap-2">
              <div className="rounded-[0.85rem] border px-3 py-2" style={{ borderColor: theme.cardBorder }}>
                <div className="flex items-center gap-1 text-[8px] font-black uppercase tracking-widest opacity-50">
                  <FaChartLine /> Opens
                </div>
                <div className="mt-1 text-sm font-black" style={{ color: theme.text }}>
                  {scanCount}
                </div>
              </div>
              <div className="rounded-[0.85rem] border px-3 py-2" style={{ borderColor: theme.cardBorder }}>
                <div className="flex items-center gap-1 text-[8px] font-black uppercase tracking-widest opacity-50">
                  <FaRegClock /> Last
                </div>
                <div className="mt-1 truncate text-[10px] font-black" style={{ color: theme.text }}>
                  {formatDateTime(member.lastScannedAt)}
                </div>
              </div>
            </div>

            <p className="mt-3 text-[10px] font-bold leading-relaxed opacity-55">
              {isOwner ? 'This NFC owns editing, content, members, and deletion.' : 'This NFC opens the owner gift content and cannot manage members.'}
            </p>
          </div>
        </div>

        {!isOwner && (
          <button
            type="button"
            onClick={() => onRemove(member)}
            className="lumirae-ds-icon-button h-9 w-9 shrink-0 text-red-500"
            aria-label={`Remove ${member.nickname || 'NFC member'}`}
            title={`Remove ${title}`}
          >
            <FaTrash size={13} />
          </button>
        )}
      </div>

      <div className="relative mt-3 rounded-[0.9rem] px-3 py-2 text-[9px] font-black uppercase tracking-widest" style={{ backgroundColor: isOwner ? theme.accentSoft : 'rgba(255,255,255,0.45)', color: isOwner ? theme.accent : theme.secondaryText }}>
        {statusLabel}
      </div>
    </div>
  );
};

export default GiftSetDeviceCard;
